import { withStyles } from '@material-ui/core';
import { compose } from 'ramda';
import { connect } from 'react-redux';

import {
  canMoveCategoryDown,
  canMoveCategoryUp,
} from '@/features/productsCategoryPage/selectors';

import SortControls from './component';
import styles from './styles';

const mapStateToProps = (state, { itemId }) => ({
  canMoveCategoryDown: canMoveCategoryDown(state, itemId),
  canMoveCategoryUp: canMoveCategoryUp(state, itemId),
});

export default compose(
  connect(mapStateToProps),
  withStyles(styles),
)(SortControls);
